import { withStyles } from '@mui/styles';
import React, { Component } from 'react';
import { connect } from 'react-redux';
const defaultStyles = () => {
    return {
        containerFade: {
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            borderRadius: '4px',
            backgroundColor: '#000000',
            zIndex: 2,
            opacity: 0
        }
    };
};
/**
 * Implements a fade out overlay.
 *
 * @augments Component
 */
class FadeOutOverlay extends Component {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { classes, opacity } = this.props;
        return (React.createElement("div", { className: classes.containerFade, style: { opacity } }));
    }
}
function _mapStateToProps(state, ownProps) {
    const { opacity } = ownProps;
    return {
        opacity
    };
}
export default connect(_mapStateToProps)(withStyles(defaultStyles)(FadeOutOverlay));
